import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { Line, Bar, Doughnut, PolarArea, Pie } from "react-chartjs-2";

// Register all necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale
);

interface LineChartProps {
  data: any;
  type?: "line" | "bar" | "doughnut" | "polarArea" | "pie";
  options?: any;
  key?: string;
}

const LineChart = React.memo(
  ({ data, type = "line", options, key }: LineChartProps) => {
    const defaultOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: "top" as const,
        },
        title: {
          display: false,
          text: "",
        },
      },
      ...options,
    };

    switch (type) {
      case "bar":
        return <Bar key={key} options={defaultOptions} data={data} />;
      case "doughnut":
        return <Doughnut key={key} options={defaultOptions} data={data} />;
      case "polarArea":
        return <PolarArea key={key} options={defaultOptions} data={data} />;
      case "pie":
        return <Pie key={key} options={defaultOptions} data={data} />;
      default:
        return <Line key={key} options={defaultOptions} data={data} />;
    }
  }
);

export default LineChart;
